import { VhpData } from '@care/mfe-data-transfer-vhp';
import { ComeFrom, ReferrerCategory } from '@/constants';

export type VhpFeatureFlagSharedData = VhpData['featureFlagSharedData'];

export enum ProgressSection {
  SHARE_NEEDS = 'SHARE_NEEDS',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  PREVIEW_MATCHES = 'PREVIEW_MATCHES',
}

export const PROGRESS_TRACKER_SECTIONS = Object.freeze([
  {
    id: ProgressSection.SHARE_NEEDS,
    name: 'Share needs',
  },
  {
    id: ProgressSection.CREATE_ACCOUNT,
    name: 'Create account',
  },
  {
    id: ProgressSection.PREVIEW_MATCHES,
    name: 'Preview matches',
  },
]);
export interface FlowState {
  flowName: string;
  memberId: string | undefined;
  czenJSessionId: string | undefined;
  referrerCookie: string | null | undefined;
  userHasAccount?: boolean;
  memberUuid: string | undefined;
  comeFrom: ComeFrom | undefined;
  clickEventLogged?: boolean;
  externalId: string | undefined | null;
  isSocialEnrollment: boolean | undefined;
  referrerCategory: ReferrerCategory;
  isEnrollmentRebrand: boolean;
  vhpFeatureFlagSharedData?: VhpFeatureFlagSharedData;
}

export type FlowAction =
  | { type: 'setFlowName'; flowName: string }
  | { type: 'setMemberId'; memberId: string }
  | { type: 'setFbAccessToken'; accessToken: string }
  | { type: 'setComeFrom'; comeFrom: ComeFrom }
  | { type: 'setClickEventLogged'; clickEventLogged: boolean }
  | { type: 'setExternalId'; externalId: string | null }
  | { type: 'setIsSocialEnrollment'; isSocialEnrollment: boolean | undefined }
  | { type: 'setMemberUuid'; memberUuid: string }
  | { type: 'setReferrerCategory'; referrerCategory: ReferrerCategory }
  | { type: 'setIsEnrollmentRebrand'; isEnrollmentRebrand: boolean }
  | { type: 'setVhpFeatureFlagSharedData'; vhpFeatureFlagSharedData: VhpFeatureFlagSharedData };
